/* eslint-disable no-underscore-dangle */
import { Button, Col, Form, Row, Select } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Title } from '../../Utils/Text';
import { getUser, getUsers, listAccounts } from '../Application/Users.business';
import { formatAccountLabel } from '../Domain/formatAccountLabel';
import { getUsersSelector } from '../Infrastructure/Users.reducer';
import { secondary } from '../../Utils/Colors';

const { Option } = Select;

const styles = {
  container: {},
  background: {
    margin: '0.7em 0em',
    borderRadius: '15px',
    padding: '1em',
    boxShadow: '3px 5px 5px 1px rgb(213,196,233, 0.5)',
  },
  button: {
    borderRadius: 25,
    backgroundColor: secondary,
  },
};

// eslint-disable-next-line react/prop-types
export default function Searcher() {
  const records = useSelector(getUsersSelector);
  const history = useHistory();
  const [form] = Form.useForm();
  const [accountOptions, setAccountOptions] = useState(null);

  const onFinish = async ({ id }) => {
    getUser(id);
    history.push(`/users/${id}`);
  };

  const onReset = () => {
    form.resetFields();
  };

  async function onSearch(val) {
    const query = String(val || '').trim();
    if (query.includes('@')) {
      try {
        const accounts = await listAccounts(query);
        if (accounts.length) {
          setAccountOptions(accounts);
          return;
        }
      } catch (error) {
        setAccountOptions(null);
      }
    }
    setAccountOptions(null);
    getUsers({ q: val });
  }

  function matchAccount(input, option) {
    if (accountOptions) return true;
    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  const userOptions = accountOptions
    ? accountOptions.map((account) => ({
        id: account.id,
        label: formatAccountLabel(account),
      }))
    : (records || []).map((record) => ({
        id: record.id,
        label: record.username || record.email,
      }));

  return (
    <div style={styles.container}>
      <Row>
        <Col span={24}>
          <Title>Usuarios</Title>
        </Col>
        <Col span={24}>
          <div style={styles.background}>
            <Form form={form} layout="inline" onFinish={onFinish} onReset={onReset}>
              <Form.Item name="id" label="Usuario">
                <Select
                  clearIcon
                  showSearch
                  style={{ width: 520 }}
                  placeholder="Selecciona un usuario"
                  optionFilterProp="children"
                  /* eslint-disable-next-line react/jsx-no-bind */
                  onSearch={onSearch}
                  /* eslint-disable-next-line react/jsx-no-bind */
                  filterOption={matchAccount}
                >
                  {userOptions.map((option) => (
                    <Option value={option.id} key={option.id}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Button type="primary" htmlType="submit" style={styles.button}>
                Seleccionar
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
}
